import { Button, Divider, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ClientAccount from "../clientManagement/clientAccount/clientAccount";

const clientUploadQueryClient = new QueryClient();

const ClientUpload = () => {
  const [selectedClientUploadNavigation, setSelectedClientUploadNavigation] =
    useState("client_upload");

  const [imageList, setImageList] = useState<any[]>([]);

  return (
    <Grid>
      <Grid
        container
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 20px 10px 20px",
        }}
      >
        <Typography variant="h4" sx={{ color: "#004680", fontWeight: "bold" }}>
          {"Client Data Upload"}
        </Typography>
      </Grid>

      <Grid
        container
        item
        xs={12}
        sx={{
          display: "flex",
          padding: "0px 20px 20px 20px",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            flexDirection: "row",
            backgroundColor: "#4C4C4C",
            borderTop: "5px solid white",
            height: "40px",
            paddingLeft: "10px",
          }}
        >
          <Button
            onClick={() => setSelectedClientUploadNavigation("client_upload")}
            sx={{
              color:
                selectedClientUploadNavigation === "client_upload"
                  ? "#38B54A !important"
                  : "white !important",
              padding: "0px 20px 0px 20px !important",
            }}
          >
            Upload Analytics Data
          </Button>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{ color: "white", backgroundColor: "white" }}
          />
          {/* <Button
            onClick={() =>
              setSelectedClientUploadNavigation("client_marketing_cost")
            }
            sx={{
              color:
                selectedClientUploadNavigation === "client_marketing_cost"
                  ? "#38B54A !important"
                  : "white !important",
              padding: "0px 20px 0px 20px !important",
            }}
          >
            Client Marketing Cost
          </Button> */}
        </Grid>
      </Grid>
      <Grid container item xs={12}>
        {selectedClientUploadNavigation === "client_upload" && (
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", padding: "0px 20px 0px 20px" }}
          >
            <Typography
              sx={{
                mt: 2,
                mb: 1,
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              {/* <label>Property Images</label> */}
              <input
                accept="image/*"
                type="file"
                multiple
                onChange={(event: any) => {
                  const filelist: any[] = Array.from(event.target.files);
                  setImageList(filelist);
                  // formik.setFieldValue("images", event.target.files);
                }}
                placeholder="Upload Analytics Data"
                name="analyticsData"
              />
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
export default ClientUpload;
